import { render, staticRenderFns } from "./AdherentInfo.vue?vue&type=template&id=04f133a4&"
import script from "./AdherentInfo.vue?vue&type=script&lang=js&"
export * from "./AdherentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports